<script setup>
defineProps({
  layoutName: {
    type: String,
    default: 'split',
  },
})
</script>

<template>
  <section class="client-layout client-layout--split" :data-layout="layoutName">
    <slot />
  </section>
</template>
